<template>
  <div class="subprogram-nba-school-team-page-summary app-content">
    <!-- Actions buttons only in summary tab -->
    <div class="subprogram-nba-school-team-page-summary__button">
      <el-button
        :class="showInfo === false ? 'subprogram-nba-school-team-page-summary__button__information is-disabled' : 'subprogram-nba-school-team-page-summary__button__information'"
        @click="showContentInfo"
      >
        <app-i18n code="entities.subprogram.nba.team.summary.information"></app-i18n>
      </el-button>
      <el-button
        :disabled="true"
        :class="showComp === false ? 'subprogram-nba-school-team-page-summary__button__competition is-disabled' : 'subprogram-nba-school-team-page-summary__button__competition'"
        @click="showContentComp"
      >
        <app-i18n code="entities.subprogram.nba.team.summary.competition"></app-i18n>
      </el-button>
    </div>
    
    <div class="app-content-page subprogram-nba-school-team-page-summary__container" >

      <!-- Team Card -->
      <app-subprogram-nba-team-card
        :subpropertyId="subpropertyId"
        :programId="programId"
        :subprogramId="subprogramId"
        :teamId="teamId"
      />
      <div class="subprogram-nba-school-team-page-summary__container__information" v-if="showInfo">
        <!-- School Card -->
        <app-subprogram-nba-school-card
          v-if="teams && teams.school"
          :schoolId="teams.school.id"
          :schoolName="teams.school.name"
          :schoolLocation="teams.school.location.name"
          :teamId="teamId"
        />

        <!-- Coaches Card -->
        <app-subprogram-nba-coach-card
          :coaches="teams.coaches"
        />

        <!-- Players Card -->
        <!-- <app-subprogram-nba-player-card
          :players="teams.players"
        /> -->
      </div>

      <div class="subprogram-nba-school-team-page-summary__container__competition" v-if="showComp">
        <span>Competition</span>
      </div>

    </div>
  </div>
</template>

<script>
import SubprogramNbaTeamCard from '@modules/subprogram/nba/components/subprogram-nba-team-card.vue';
import SubprogramNbaSchoolCard from '@modules/subprogram/nba/components/subprogram-nba-school-card.vue';
import SubprogramNbaCoachCard from '@modules/subprogram/nba/components/subprogram-nba-coach-card.vue';
import SubprogramNbaPlayerCard from '@modules/subprogram/nba/components/subprogram-nba-player-card.vue';

import CoachListTable from '@modules/coach/components/coach-list-table.vue';

import { mapActions, mapGetters } from 'vuex';
import { get } from 'lodash';

export default {
  name: 'subprogram-nba-school-team-page-summary',

  components: {
    [SubprogramNbaTeamCard.name]: SubprogramNbaTeamCard,
    [SubprogramNbaSchoolCard.name]: SubprogramNbaSchoolCard,
    [SubprogramNbaCoachCard.name]: SubprogramNbaCoachCard,
    [SubprogramNbaPlayerCard.name]: SubprogramNbaPlayerCard,
    [CoachListTable.name]: CoachListTable,
  },

  props: {
    teamId: {
      type: String,
      required: true,
    },
    programId: {
      type: String,
      required: true,
    },
    subprogramId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showInfo: true,
      showComp: false,
    }
  },

  computed: {
    ...mapGetters({
      teams: 'subprogram/nbaTeam/summary/teams',
      loading: 'subprogram/nbaTeam/summary/loading',
      currentManage: 'auth/manage/currentManage',
    }),
    subpropertyId() {
      return get(
        this,
        'currentManage.subproperty.id',
        null,
      );
    },
  },

  async created() {
    await this.doFind(this.teamId);
  },

  methods: {
    ...mapActions({
      doFind: 'subprogram/nbaTeam/summary/doFind',
    }),
    showContentInfo() {
      this.showInfo = true;
      this.showComp = false;
    },
    showContentComp() {
      this.showInfo = false;
      this.showComp = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.subprogram-nba-school-team-page-summary {
  &__button {
    display: grid;
    grid-template-areas: 'info compe';
    justify-content: right;

    &__information {
      margin: 0;
      border: none;
      border-radius: 0px !important;
      border-top-left-radius: 25px !important;
      border-bottom-left-radius: 25px !important;
      &.is-disabled {
        color: #c5c5c5;
        background-color: #ececec;
        box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
        cursor: pointer;
      }
      &:focus, &:hover {
        background-color: #ffffff;
        color: #404040;
      }
    }
    &__competition {
      margin: 0;
      border: none;
      border-radius: 0px !important;
      border-top-right-radius: 25px !important;
      border-bottom-right-radius: 25px !important;
      &__is-disabled {
        color: #c5c5c5;
        background-color: #ececec;
        box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
        cursor: pointer;
      }
      &:focus, &:hover {
        background-color: #ffffff;
        color: #404040;
      }
      &.is-disabled {
        color: #c5c5c5;
        background-color: #ececec;
        box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
      }
    }
  }

  &__container {
    &__information, &__competition {
      padding: 40px 64px;
    }
  }
}
</style>

<style>
.subprogram-nba-school-team-page-summary .el-table:not(.el-table--simple) td:last-of-type .cell {
  padding: 0 30px;
}

.subprogram-nba-school-team-page-summary .el-table__row {
  cursor: default;
}
</style>
